import Icon from "components/icons";
import Link from "next/link";
import Modal from "components/Modal";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { unescape } from "lodash";

const BottomContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1.25rem;
  margin: 2.5rem 0 0 0;
  width: 100%;

  /* Only stack tiles for smaller than ~iPhone 6 */
  @media (min-width: 360px) {
    grid-template-columns: 1fr 1fr;
  }

  ${({ theme }) => theme.mq.sm`
    grid-gap: 1.4375rem;
  `};
`;

const LightParagraph = styled.p`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: ${({ theme }) => theme.fontSize(1)};
  font-weight: 400;

  ${({ theme }) => theme.mq.sm`
    font-size: ${theme.fontSize(2)};
    margin: 0;
  `};
`;

const LinkText = styled.p`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.1875rem;
  margin-top: 1.5625rem;
  text-align: center;
`;

const LinkTile = styled.a`
  align-items: center;
  box-shadow: 0rem 0.125rem 0.375rem rgba(138, 168, 181, 0.1253);
  border: 0.0625rem solid ${({ theme }) => theme.themeColors.blue4};
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  padding: 1.875rem 0.3125rem;
  transition: border-color 0.3s;

  &:hover {
    border-color: ${({ theme }) => theme.themeColors.primary};
    box-shadow: 0rem 0.5625rem 1.0625rem rgba(138, 168, 181, 0.122542);
  }

  ${({ theme }) => theme.mq.md`
    padding: 1.875rem;
  `}
`;

const LoginReferHead = styled.div`
  font-size: ${({ theme }) => theme.fontSize(4)};
  line-height: 1.8rem;
  margin: 0 0 1rem 0;

  ${({ theme }) => theme.mq.sm`
    font-size: ${theme.fontSize(5)};
    line-height: 2.4rem;
  `};
`;

const OrangeSpan = styled.span`
  color: ${({ theme }) => theme.themeColors.orange1};
`;

const OuterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mq.lg`
    max-width: 38rem;
  `};
`;

const TopContentWrapper = styled.div`
  width: 100%;
`;

function CustomerRedirectModal({ asPath, businessName, close, show, title }) {
  const params = new URLSearchParams({ next: asPath });
  const next = `/omniauth/redirect?${params}`;

  return (
    <Modal show={show} close={close}>
      <OuterContentWrapper>
        <TopContentWrapper>
          <LoginReferHead>
            {title} <OrangeSpan>{unescape(businessName)}</OrangeSpan>
          </LoginReferHead>
          <LightParagraph>
            We want to make sure you have access to your appointment details,
            that&#39;s why we need you to log in or sign up first.
          </LightParagraph>
        </TopContentWrapper>
        <BottomContentWrapper>
          <Link
            passHref
            href={{
              pathname: `/customer/auth`,
              query: { next },
            }}
          >
            <LinkTile>
              <Icon name="key-75" />
              <LinkText>
                Log in <br /> to GoodFriend
              </LinkText>
            </LinkTile>
          </Link>
          <Link
            passHref
            href={{
              pathname: `/customer/auth`,
              query: { next },
            }}
          >
            <LinkTile>
              <Icon name="tags-75" />
              <LinkText>
                Create
                <br /> an account
              </LinkText>
            </LinkTile>
          </Link>
        </BottomContentWrapper>
      </OuterContentWrapper>
    </Modal>
  );
}

export default CustomerRedirectModal;

CustomerRedirectModal.propTypes = {
  asPath: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  businessName: PropTypes.string,
  close: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
};

CustomerRedirectModal.defaultProps = {
  asPath: "/",
  businessName: "",
  close: () => {},
  show: false,
  title: "Book your appointment with",
};
